import axios from "axios"

const apiInstance = axios.create({
    baseURL: "https://bazigar-api.skylinkapi.online",
    // baseURL: "http://localhost:5000"
});

export default apiInstance
